import React from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import * as actions from '../store/actions/documentActions';
import Header from '../containers/header';
import Footer from '../containers/footer';
import Card from '../components/Card';
import ListCard from '../components/List-Card';
import CustomForm from '../components/form';
const path = require('path'); 

class HistoryList extends React.Component {
    constructor(props){
        super(props);
        this.state = {
            page: 1,
            cards: 4,
            window: 5
        };
        
    }
    pagination = (documents, page, cards ) => {
        const trimStart = (page - 1) * cards
        const trimEnd = trimStart + cards
        const trimmedData = documents.slice(trimStart, trimEnd)
        const pages = Math.ceil(documents.length/cards)
        return {
          newDocuments : trimmedData,
          pages : pages
        }
    }
    pageButtons = (pages) => {
      var list = []
      var maxLeft = (this.state.page - Math.floor(this.state.window/2))
      var maxRight = (this.state.page + Math.floor(this.state.window/2))
      if (maxLeft<1) {
        maxLeft = 1
        maxRight = this.state.window
      }
      if  (maxRight>pages) {
        maxLeft = pages - (this.state.window - 1)
        maxRight = pages
        if (maxLeft<1) {
            maxLeft = 1
        }
      }
      for (let page = maxLeft; page<= maxRight; page++){
      list.push(page)
      }
      return list
    }
    pageButtonClick = (event) => {
      const buttonclick = document.querySelectorAll('.page-buttons');
        for (let item of Array.from(buttonclick)) {
        if (item  === event.target) {
        item.style.backgroundColor = 'cyan';
        }
        else{
          item.style.backgroundColor = '';
        }
      }
      this.setState({
        page: Number(event.target.value)
       });
    }
    componentDidMount() { 
      if (this.props.token) {
        
        this.props.get_documents(this.props.token);
        }
    }
      
    componentDidUpdate(prevProps){
      
      if (prevProps.token !== this.props.token) {
        
        this.props.get_documents(this.props.token);
        }
    }
    
       
    render() {
      
      var data = this.pagination(this.props.documents, this.state.page, this.state.cards);
      
      const listItems = data.newDocuments.map((document)  => <Card key = {document.pk} title = {<a className= 'blabla' href ={`/workArea/${document.pk}`}>{`Filename: ${path.basename(document.document, '.docx' )}`}</a>} content = {<p>{`Description: ${document.description}`}</p>} stats = {`Uploaded at: ${(document.uploaded_at).split('.')[0]}`} /> );
      let newt, newte  = null   
      const buttons = this.pageButtons(data.pages).map((page) => <button value={page} onClick= {this.pageButtonClick} key = {page} className= 'page-buttons'>{page}</button>);
      
      if ((this.state.page !== 1 ) && (this.props.documents.length !== 0) ){
          newt = <button value={1} onClick= {this.pageButtonClick} className='newt'>&#171;FirstPAGE</button>
       }
       if ((this.state.page !== data.pages) && (this.props.documents.length !== 0) ){
        newte = <button value={data.pages} onClick= {this.pageButtonClick} className='newt'>LastPage&#187;</button>
     } 
     
    return (
            <div className='body'>
         <Header change={this.handleClick} >
         <ul className='specialNavigation' >
         <li><Link to='/' className='click' >Home</Link></li>
        
            </ul>
             </Header>
         
         <div className='page-content'>
         <div className='input-area' id='home'>
             < CustomForm/>
         </div>
         <div className='how-it-works-area' id='how-it-works-area'> <ListCard content={<h1><a className='headerLink' href='#list-area'>Your History</a></h1>}/> </div>
        <div className='list-area' id='list-area'>
          {listItems}
      <div className='button-area'>{newt} {buttons} {newte}</div>
     </div>
        
         </div> 
       <Footer/>
        </div>

)
    };    
}    
const mapStateToProps = state => {
  return {
    token: state.token,
    documents: state.documents 
  }
}
const mapDispatchToProps = dispatch => {
  return {
    get_documents: (token) => dispatch(actions.get_documents(token))
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(HistoryList);